import { BillingType } from '~/components/BillModal/BillClientModal.types';
export const isFirstItemUntouched = (items)=>{
    if (items.length !== 1) return false;
    const [firstItem] = items;
    if (firstItem.note) return false;
    return firstItem.type === BillingType.Charge ? !firstItem.charge.serviceTemplateId : !firstItem.service.quantity;
};
const isEmptyCharge = (item)=>item.type === BillingType.Charge && !item.note && !item.charge.serviceTemplateId;
export const initialItemsForDefault = (defaultItem)=>isEmptyCharge(defaultItem) ? [] : [
        defaultItem
    ];
